import { IconProps } from './IconProps';

export const UhxIcon = (props: IconProps) => {
    return (
        <svg
            className={props.className}
            style={props.style}
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M8.25706 0L12 0L7.73041 6.03762L10.5517 9.98746H6.80878L5.88715 8.67085L3.59248 12H6.67572e-06L4.00628 6.03762L1.10972 2.1442L4.85267 2.1442L5.88715 3.47963L8.25706 0Z" fill="url(#paint0_linear_9781_18653)" />
            <defs>
                <linearGradient id="paint0_linear_9781_18653" x1="-8" y1="-6.5" x2="24" y2="24" gradientUnits="userSpaceOnUse">
                    <stop />
                    <stop offset="1" stop-color="#666666" />
                </linearGradient>
            </defs>
        </svg>
    );
};